import { render, staticRenderFns } from "./Duel.vue?vue&type=template&id=325b134c&scoped=true&"
import script from "./Duel.vue?vue&type=script&lang=js&"
export * from "./Duel.vue?vue&type=script&lang=js&"
import style0 from "./Duel.vue?vue&type=style&index=0&id=325b134c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325b134c",
  null
  
)

export default component.exports